<template>
  <div class="modal" v-if="showModal">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="payrollDetailsModalLabel">Payroll Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span  @click="closeModal" aria-hidden="true">&times;</span>
          </button>
        </div>
      <div class="modal-body">
        <p>modal content</p>
        <p>{{ content }}</p>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: String,
    content: String,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
  
  <style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  max-width: 40%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-right: 30px;
}

.close {
    text-align: right;
}


</style>
  